<template>
    <div class="scoreHeader">
        <h3>x {{questionsLeft}}</h3>
        <div class="scoreContainer">
            <app-score :score="displayScore" :newScore="newScore" :smallFont="true"></app-score>
        </div>
        <h2>Highscore:</h2>
    </div>
</template>

<script>
import { eventBus } from "../main";
import Score from "./score.vue";

export default {
    name: "scoreHeader",
    data() {
        return {
            scoreInterval: null,
            audioPoints: new Audio(),
            audioVictory: new Audio()
        };
    },
    components: {
        appScore: Score
    },
    props: {
        questionsLeft: {
            type: Number,
            default: 0
        },
        displayScore: {
            type: Number,
            default: 0
        },
        calculateScore: {
            type: Boolean,
            default: false
        },
        newScore: {
            type: Number,
            default: 0
        }
    },
    computed: {},
    methods: {
        countToScore() {
            this.audioPoints.play();
            this.displayScore = 0;
            this.scoreInterval = setInterval(() => {
                this.displayScore++;
                if (this.displayScore == this.newScore ) {
                    this.audioPoints.pause();
                    this.audioPoints.currentTime = 0;
                    if(this.displayScore == 100) {
                        this.audioVictory.play();
                    }
                    clearInterval(this.scoreInterval);
                }
            }, 50);
        }
    },
    created() {
        eventBus.$on("displayScore", props => {
            this.countToScore();
        });
    },
    mounted() {
        this.audioPoints.src = "audio/score.mp3";
        this.audioVictory.src = "audio/victory.mp3";
    }
};
</script>

<style scoped>
.scoreContainer {
    margin-top: 2%;
    height: 100%;
    width: 35%;
    float: right;
}
h2 {
    color: #fff;
    font-size: 2.25vh;
    float: right;
    margin: 2.75vh 0;
}
h3 {
    color: #fff;
    font-size: 2.75vh;
    float: left;
    margin: 2vh 0;
}
.scoreHeader {
    display: inline-block;
    float: right;
    height: 8%;
    width: 85%;
    background: #ffc400;
}
</style>
